import { Collapsible } from 'containers/LawyerDocumentsPage/typings';

export const handleCollapseRow = (
  index: number,
  expandRow: Collapsible,
  setExpandRow: React.Dispatch<React.SetStateAction<Collapsible>>,
  clearData?: Function,
) => () => {
  const rowsToExpand: Collapsible =
    expandRow !== undefined
      ? { [index]: !expandRow[index] }
      : { [index]: true }; // initialize as expanded on first toggle

  setExpandRow(rowsToExpand);
  if (clearData) {
    clearData();
  }
  return rowsToExpand;
};
